import { assert_true } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { TYPE__class_constructor } from '@shared/types/TYPE__class_constructor';
export function FN_SERIALIZATION__check_stub<T>(class_name: string, class_object: TYPE__class_constructor<T>) {
  let stub = (class_object as any).STUB;
  if (stub == undefined) return;
  if (!(stub instanceof DTO__base)) return;

  assert_true(stub.is_stub(), { class_name });
}
